import { useInfiniteQuery } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { InfiniteQueryConfig, queryClient } from '@/src/lib/react-query/react-query';
import { BASE_PROJECT_PATH, generateRoutePath } from '@/src/routes';

import { INBOX_API_KEY } from '../../../../api/config';
import { View } from '../../../../types';
import { EMAIL_THREAD_PAGE_LIMIT } from '../components/EmailThreadViewer/EmailEntries/EmailEntries';

// const url = `${PREFIX_URL}/v01/inboxThread`;
const url = `${PREFIX_URL}/inbox-threads/:inboxEntryId/emails`;

type EmailEntriesResponse = {
  // data: {
  //   result: any;
  //   count: {
  //     current_page: number;
  //     last_page: number;aq
  //     total_count: number;
  //   };
  // };
  data: {
    emails: any[];
    'total-count': number;
  };
};

export const getEmailEntries = ({
  inboxEntryId,
  projectId,
  params,
}): Promise<EmailEntriesResponse> => {
  return axios.get(generateRoutePath(url, { projectId, inboxEntryId }), {
    params,
    // params: {
    //   ...params,
    //   page: 7,<
    // },
  });
};

export const emailEntriesKeys = {
  all: ['emailEntries'] as const,
  lists: ({
    projectId,
    inboxEntryId,
    trash,
  }: {
    projectId: string;
    inboxEntryId: number;
    trash?: boolean;
  }) =>
    [
      INBOX_API_KEY,
      ...emailEntriesKeys.all,
      projectId,
      inboxEntryId,
      ...(trash !== undefined ? [trash] : []),
    ] as const,
};

type QueryFnType = typeof getEmailEntries;

type useEmailEntriesOptions = {
  projectId: string;
  inboxEntryId: number;
  trash: boolean;
  limit?: number;
  config?: InfiniteQueryConfig<QueryFnType>;
};

export const useEmailEntries = ({
  projectId,
  inboxEntryId,
  trash,
  limit,
  config,
}: useEmailEntriesOptions) => {
  return useInfiniteQuery({
    queryKey: [INBOX_API_KEY, ...emailEntriesKeys.all, projectId, inboxEntryId, trash, limit],
    queryFn: ({ pageParam = 1 }) =>
      getEmailEntries({
        params: { page: pageParam, trash: Number(trash), limit },
        projectId,
        inboxEntryId,
      }),
    staleTime: Infinity,
    getNextPageParam: (lastPage, allPages) => {
      // Assuming lastPageData is an array of objects and totalCount is available
      const currentPageCount = allPages.length * limit;

      if (currentPageCount < lastPage.data['total-count']) {
        // If there are more items to fetch, return the next page number
        return allPages.length + 1;
      }

      // If all items have been fetched, return undefined to stop fetching
      return undefined;
    },
    ...config,
  });
};

export const getCurrentEmailEntriesCountFromCache = ({ projectId, inboxEntryId, filter }) => {
  const emailEntriesPages = queryClient.getQueryData([
    ...emailEntriesKeys.lists({
      projectId,
      inboxEntryId,
      trash: filter === View.Trash ? true : false,
    }),
    EMAIL_THREAD_PAGE_LIMIT,
  ]) as any;

  return emailEntriesPages.pages?.[0].data['total-count'] || 0;
};
